import { createContext, useMemo, type PropsWithChildren } from "react";
import type { CoachReviewPromises } from "../types";

interface CoachReviewsContextValue {
	gameId: number;
	gameTeamId: number;
	teamId: number | null;
	userId: number;
	promises: CoachReviewPromises;
}

export const CoachReviewsContext = createContext<CoachReviewsContextValue | null>(null);

export const CoachReviewsProvider = ({
	gameId,
	gameTeamId,
	teamId,
	userId,
	promises,
	children,
}: PropsWithChildren<CoachReviewsContextValue>) => {
	const value = useMemo(
		() => ({ gameId, gameTeamId, teamId, userId, promises }),
		[gameId, gameTeamId, teamId, userId, promises]
	);

	return <CoachReviewsContext.Provider value={value}>{children}</CoachReviewsContext.Provider>;
};
